import React from 'react';
import { Settings } from 'lucide-react';
import { cn } from '@/lib/utils';
import { SIDEBAR_ACTION_HOVER_GROUP } from '../utils/sidebar-action-hover';

interface RotatingSettingsIconProps {
  className?: string;
  size?: number;
  hoverGroup?: string;
}

export const RotatingSettingsIcon: React.FC<RotatingSettingsIconProps> = ({
  className,
  size,
  hoverGroup = SIDEBAR_ACTION_HOVER_GROUP,
}) => {
  return (
    <Settings
      size={size}
      className={cn(
        'h-4 w-4 shrink-0 transition-transform duration-300',
        `group-hover/${hoverGroup}:rotate-45`,
        className,
      )}
    />
  );
};
